import { render } from "./FishBook.vue?vue&type=template&id=71ebf126&ts=true"
import script from "./FishBook.vue?vue&type=script&lang=ts"
export * from "./FishBook.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__